import React from "react";

import { Button, Flex } from "antd";

import type { ExperimentFlowStepKey } from "../types/experimentFlow.types";

const secondaryActionButtonStyle: React.CSSProperties = {
  borderColor: "rgba(255, 255, 255, 0.12)",
  background: "rgba(255, 255, 255, 0.05)",
  color: "#FFFFFF",
  fontWeight: 500,
};

const accentActionButtonStyle: React.CSSProperties = {
  borderColor: "rgba(244, 193, 69, 0.3)",
  background: "rgba(244, 193, 69, 0.2)",
  color: "#F4C145",
  fontWeight: 500,
};

const disabledActionButtonStyle: React.CSSProperties = {
  borderColor: "rgba(255, 255, 255, 0.12)",
  background: "rgba(255, 255, 255, 0.04)",
  color: "rgba(255, 255, 255, 0.32)",
  fontWeight: 500,
  cursor: "not-allowed",
};

interface ExperimentFlowActionsProps {
  currentStepKey: ExperimentFlowStepKey;
  canContinue: boolean;
  showContinue?: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  onPrevious: () => void;
  onContinue: () => void;
}

export const ExperimentFlowActions: React.FC<ExperimentFlowActionsProps> = ({
  currentStepKey,
  canContinue,
  showContinue = true,
  isCreating,
  isUpdating,
  onPrevious,
  onContinue,
}) => {
  const continueLabel =
    currentStepKey === "context" && isCreating
      ? "Saving..."
      : currentStepKey === "context" && isUpdating
        ? "Updating..."
        : currentStepKey === "research" && isUpdating
          ? "Updating..."
          : "Continue";

  return (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      <Button
        onClick={onPrevious}
        disabled={currentStepKey === "context"}
        style={secondaryActionButtonStyle}
      >
        Previous
      </Button>
      {showContinue ? (
        <Button
          onClick={onContinue}
          disabled={!canContinue}
          style={
            canContinue ? accentActionButtonStyle : disabledActionButtonStyle
          }
        >
          {continueLabel}
        </Button>
      ) : null}
    </Flex>
  );
};
